import functions from '../../functions';

if (window.wp && window.wp.ajax) {
    const { registerBlockType } = window.wp.blocks;
    const { InspectorControls, MediaUpload, MediaUploadCheck, InnerBlocks } = window.wp.editor;
    const { PanelBody, Button } = window.wp.components;
    const { createElement } = window.wp.element;

    registerBlockType('custom-gutenberg/two-image-feature', {
        title: 'Two Image Feature Box',
        description: 'Main large image, small circular image, and floating text (InnerBlocks).',
        icon: 'format-image',
        category: 'custom-cards',

        attributes: {
            mainImage: { type: 'string', default: '' },
            smallImage: { type: 'string', default: '' },
            anchor: { type: 'string', default: '' },
            classes: { type: 'string', default: '' }
        },

        edit: function (props) {
            const { attributes, setAttributes } = props;
            const { mainImage, smallImage, anchor, classes } = attributes;

            let className = props.className;
            className = functions.getClassNames(className);
            if (classes !== className) setAttributes({ classes: className });

            /* ---- Image Selectors ---- */
            function selectMainImage(media) {
                setAttributes({ mainImage: media.url });
            }

            function selectSmallImage(media) {
                setAttributes({ smallImage: media.url });
            }

            return [
                /* ======================
                   SIDEBAR CONTROLS
                ======================= */
                createElement(
                    InspectorControls,
                    {},
                    createElement(
                        PanelBody,
                        { title: 'Images', initialOpen: true },

                        /* MAIN IMAGE PICKER */
                        createElement('div', { className: 'editor-label' }, 'Main Image'),
                        createElement(MediaUploadCheck, {},
                            createElement(MediaUpload, {
                                onSelect: selectMainImage,
                                type: 'image',
                                value: mainImage,
                                render: ({ open }) =>
                                    createElement(Button, { onClick: open, isPrimary: true },
                                        mainImage ? 'Replace Main Image' : 'Select Main Image'
                                    )
                            })
                        ),

                        createElement('hr'),

                        /* SMALL IMAGE PICKER */
                        createElement('div', { className: 'editor-label' }, 'Small Circular Image'),
                        createElement(MediaUploadCheck, {},
                            createElement(MediaUpload, {
                                onSelect: selectSmallImage,
                                type: 'image',
                                value: smallImage,
                                render: ({ open }) =>
                                    createElement(Button, { onClick: open, isSecondary: true },
                                        smallImage ? 'Replace Small Image' : 'Select Small Image'
                                    )
                            })
                        )
                    )
                ),

                /* ======================
                   BLOCK CONTENT (EDITOR)
                ======================= */
                createElement(
                    'div',
                    { id: anchor, className: classes + " position-relative" },

                    /* MAIN IMAGE */
                    mainImage
                        ? createElement('img', {
                              src: mainImage,
                              className: 'img-fluid rounded w-100 main-feature-image'
                          })
                        : createElement('div', { className: 'image-placeholder' }, 'Select main image'),

                    /* FLOATING TEXT (InnerBlocks) */
                    createElement(
                        'div',
                        {
                            className: 'floating-text-box position-absolute top-0 end-0 p-3 bg-white shadow-sm rounded'
                        },
                        createElement(InnerBlocks)
                    ),

                    /* SMALL CIRCLE IMAGE */
                    smallImage
                        ? createElement('img', {
                              src: smallImage,
                              className: 'img-fluid small-circle-image position-absolute rounded-circle border border-white shadow'
                          })
                        : createElement('div', { className: 'small-image-placeholder' }, 'Select small image')
                )
            ];
        },

        save: function (props) {
            const { mainImage, smallImage, anchor, classes } = props.attributes;

            var hasInnerBlocks = props.clientId && wp.data.select('core/block-editor').getBlocks(props.clientId).length > 0;

            return createElement(
                'div',
                { id: anchor, className: classes + " position-relative" },

                /* MAIN IMAGE */
                mainImage
                    ? createElement('img', {
                          src: mainImage,
                          className: 'cover-image img-fluid rounded w-100 main-feature-image'
                      })
                    : null,

                /* FLOATING TEXT (FRONTEND) */
                hasInnerBlocks ? createElement(
                    'div',
                    {
                        className: 'floating-text-box p-3 bg-white shadow-sm rounded'
                    },
                    createElement(InnerBlocks.Content)
                ) : null,

                /* SMALL CIRCLE IMAGE */
                smallImage
                    ? createElement('img', {
                          src: smallImage,
                          className: 'cover-image img-fluid small-circle-image position-absolute rounded-circle border'
                      })
                    : null
            );
        }
    });
}
